import { useRef, useState } from "react";
import { ip } from "../../api/api";
import { HorizontalLayout, VerticalLayout } from "../layout";
import { StandardButton } from "../../atoms/buttons";
import { Spinner } from "../../atoms/spinner";
import { icon } from "../../functions/icons";
import { set } from "date-fns";
import JSConfetti from "js-confetti";
var confettiEnabled = false;
export default function AssessmentFinished({elearningInformation, id}) {
  const [completionEmail, setCompletionEmail] = useState("");
  const [emailSubmitting, setEmailSubmitting] = useState(false);
  const [emailSubmitted, setEmailSubmitted] = useState(false);  
  const [emailError, setEmailError] = useState("");
  const jsConfettiRef = useRef(null);
  const triggerConfetti = () => {
    const jsConfetti = jsConfettiRef.current || new JSConfetti();
    jsConfettiRef.current = jsConfetti;
    if (!confettiEnabled) {
      confettiEnabled = true;
      const interval = setInterval(() => jsConfetti.addConfetti(), 150);
      setTimeout(() => { clearInterval(interval); confettiEnabled = false; }, 1000);
    }
  };
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const handleEmailSubmit = async () => {
      if (emailSubmitted) return;
      if (!isValidEmail(completionEmail)) return setEmailError("Voer een geldig e-mailadres in.");
      setEmailSubmitting(true);
      try {
        const parsed = JSON.parse(localStorage.getItem(`embed_${id}`) || "{}");
        const authToken = parsed?.token;
        const response = await fetch(`${ip}/api/embed/${id}/results`, {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Auth-Token": authToken },
          body: JSON.stringify({ email: completionEmail })
        });
        if (response.ok) setEmailSubmitted(true);
        else setEmailError("Er is iets misgegaan bij het versturen van de resultaten. Probeer het opnieuw.");
      } catch { setEmailError("Er is iets misgegaan bij het versturen van de resultaten. Probeer het opnieuw."); }
      finally { setEmailSubmitting(false); }
  };

  return (
    <div style={{ background: "var(--grey-50)", height: "100vh" }}>
      <div
        style={{ backgroundImage: `url('${elearningInformation.image_url}')` }}
        className="topbar-embed-bg"
      >
        <div className="topbar-embed">{elearningInformation.title}</div>
      </div>
      <VerticalLayout
        className="center-all phone-result-container"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          maxWidth: "400px",
          padding: "2rem",
        }}
      >
        <div style={{ color: "green", marginBottom: "0.5rem" }}>{icon("checkbox-check", 96)}</div>
        <h6 style={{ color: "var(--grey-900)", marginBottom: "1rem" }}>
          Je hebt de e-learning afgerond.
        </h6>
        <div style={{ width: "100%", height: "auto", marginBottom: "1rem" }}>
          <p style={{ margin: "0 0 1rem 0", textAlign: "left", color: "var(--grey-600)", fontSize: "0.9rem" }}>
            Vul je mailadres in, dan ontvang je de resultaten direct in je mailbox.
          </p>
          <div style={{ marginBottom: "1rem", textAlign: "left" }}>
            <input
              type="email"
              value={completionEmail}
              onChange={(e) => setCompletionEmail(e.target.value)}
              placeholder="voorbeeld@example.com"
              style={{
                width: "100%",
                padding: "0.75rem",
                borderRadius: "0.5rem",
                border: "1px solid var(--grey-300)",
                fontSize: "1rem",
                boxSizing: "border-box",
              }}
            />
            {emailError !== "" && <label style={{ color: "red", fontSize: "0.75rem" }}>{emailError}</label>}
          </div>
          <HorizontalLayout className="phone-result">
            <StandardButton
              onClick={handleEmailSubmit}
              disabled={emailSubmitting || emailSubmitted}
              style={{
                background: emailSubmitted ? "var(--success-500)" : "var(--primary-500)",
                padding: "0.75rem",
                marginLeft: "0rem",
              }}
            >
              {emailSubmitting ? (
                <Spinner color="white" size="1rem" />
              ) : emailSubmitted ? (
                "Resultaten verzonden!"
              ) : (
                "Resultaten ontvangen"
              )}
            </StandardButton>
            <StandardButton
              onClick={triggerConfetti}
              style={{
                background: "var(--success-500)",
                padding: "0.75rem 1.5rem",
              }}
            >
              🎉
            </StandardButton>
          </HorizontalLayout>
        </div>
      </VerticalLayout>
    </div>
  );
};


var confettiEnabled = false;
export  function AssessmentFinishedTap({elearningInformation, id, code, goBack}) {
  
  const [emailSubmitting, setEmailSubmitting] = useState(false);
  const [emailSubmitted, setEmailSubmitted] = useState(false);  
  const [emailError, setEmailError] = useState("");
  const jsConfettiRef = useRef(null);
    const triggerConfetti = () => {
    const jsConfetti = jsConfettiRef.current || new JSConfetti();
    jsConfettiRef.current = jsConfetti;
    if (!confettiEnabled) {
      confettiEnabled = true;
      const interval = setInterval(() => jsConfetti.addConfetti(), 150);
      setTimeout(() => { clearInterval(interval); confettiEnabled = false; }, 1000);
    }
  };
  const handleEmailSubmit = async () => {      
      setEmailSubmitting(true);
      try {
        const parsed = JSON.parse(localStorage.getItem(`embed_${id}`) || "{}");
        const authToken = parsed?.token;
        const response = await fetch(`${ip}/api/cards/results`, {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Auth-Token": authToken },
          body: JSON.stringify({ card_code: code, id_course: id })
        });
        if (response.ok) setEmailSubmitted(true);
        else setEmailError("Er is iets misgegaan bij het versturen van de resultaten. Probeer het opnieuw.");
      } catch { setEmailError("Er is iets misgegaan bij het versturen van de resultaten. Probeer het opnieuw."); }
      finally { setEmailSubmitting(false); }
  };


  const backToFeed = async () => {
     await  handleEmailSubmit()
     setTimeout(() => {
        goBack()
     }, 1000);

  }
  return (
    <div style={{ background: "var(--grey-50)", height: "100vh" }}>
      <div
        style={{ backgroundImage: `url('${elearningInformation.image_url}')` }}
        className="topbar-embed-bg"
      >
        <div className="topbar-embed">{elearningInformation.title}</div>
      </div>
      <VerticalLayout
        className="center-all phone-result-container"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          maxWidth: "400px",
          padding: "2rem",
        }}
      >
        <div style={{ color: "green", marginBottom: "0.5rem" }}>{icon("checkbox-check", 96)}</div>
        <h6 style={{ color: "var(--grey-900)", marginBottom: "1rem" }}>
          Je hebt de e-learning afgerond.
        </h6>
        <div style={{ width: "100%", height: "auto", marginBottom: "1rem" }}>
          <p style={{ margin: "0 0 1rem 0", textAlign: "left", color: "var(--grey-600)", fontSize: "0.9rem" }}>
            De resultaten zijn opgeslagen. Verstuur hieronder direct naar je mailadres en ga terug naar je feed.
          </p>

          <HorizontalLayout className="phone-result">
            <StandardButton
              onClick={backToFeed}
              disabled={emailSubmitting || emailSubmitted}
              style={{
                background: emailSubmitted ? "var(--success-500)" : "var(--primary-500)",
                padding: "0.75rem",
                marginLeft: "0rem",
              }}
            >
              {emailSubmitting ? (
                <Spinner color="white" size="1rem" />
              ) : emailSubmitted ? (
                "Resultaten verzonden!"
              ) : (
                "Resultaten ontvangen"
              )}
            </StandardButton>
            <StandardButton
              onClick={triggerConfetti}
              style={{
                background: "var(--success-500)",
                padding: "0.75rem 1.5rem",
              }}
            >
              🎉
            </StandardButton>
          </HorizontalLayout>
        </div>
      </VerticalLayout>
    </div>
  );
};